import React from 'react';
import PropTypes from 'prop-types';
import className from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';

const CardService = ({ to, media, title, description, children, width }) =>
  <Card className="card-span cursor-pointer h-100">
    <div className="card-span-img">
      {!!media.src ?
        <img width={width ? width : 100} style={{ WebkitFilter: 'drop-shadow(3px 3px 3px rgba(0,0,0,.5))' }} src={media.src} alt={description && description} />
        :
        <FontAwesomeIcon icon={media.icon} className={className({ [`text-${media.color}`]: media.color }, media.className)} />
      }
    </div>
    <CardBody className="pt-7 pb-4">
      <h5 className="mb-2 my-1">{title}</h5>
      {description && <p>{description}</p>}
      {children}
      {!!to && <Link to={to.path} className={to.className}>{to.name}</Link>}
    </CardBody>
  </Card>

CardService.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.node
};

export default CardService;